"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const callableGetAllUsers = async ({ callbacks, functionId, executeProcesses, processor, }) => {
    try {
        const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)('getAllUsers', processor);
        const appId = processor.root.getAppId();
        if (!appId) {
            throw new Error('setUserCustomData: no appId found in app');
        }
        const memberRef = processor.root.firebase.database()
            .ref(`projects/${projectId}/apps/${appId}/members`);
        const rawMembersValue = (await memberRef.once('value')).val();
        let membersValue = (0, valueIsRecord_1.default)(rawMembersValue) ? rawMembersValue : {};
        membersValue = Object
            .entries(membersValue)
            .reduce((newMembersValue, [key, value]) => {
            var _a, _b;
            const newData = Object.assign(Object.assign({}, newMembersValue), { [key]: value });
            if (newData && key) {
                (_a = newData[key]) === null || _a === void 0 ? true : delete _a.hashedPassword;
                (_b = newData[key]) === null || _b === void 0 ? true : delete _b.cloudMessagingTokens;
            }
            return newData;
        }, {});
        executeProcesses(functionId, callbacks.successProcess, membersValue);
    }
    catch (error) {
        executeProcesses(functionId, callbacks.errorProcess, error);
    }
};
exports.default = callableGetAllUsers;
